module.exports = __webpack_public_path__ + "media/images/landing/eno/product-13-c01a6942f3ccefe5292f4fe9996152a3.png";